import { render, staticRenderFns } from "./TopicsStudentsList.vue?vue&type=template&id=537a37c4&scoped=true"
import script from "./TopicsStudentsList.vue?vue&type=script&lang=js"
export * from "./TopicsStudentsList.vue?vue&type=script&lang=js"
import style0 from "./TopicsStudentsList.vue?vue&type=style&index=0&id=537a37c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a37c4",
  null
  
)

export default component.exports